module.exports = __webpack_public_path__ + "static/media/Slab.a7bc81ac.svg";